const formRows = [
  {
    span: 24,
    label: '标题',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: 'title',
    allowClear: true
  },
  {
    span: 24,
    label: '简介',
    component: 'RichTextEdit',
    placeholder: '输入内容描述',
    prop: 'synopsis',
  },
  {
    span: 24,
    label: '发布单位',
    component: 'AInput',
    placeholder: '请输入发布单位',
    prop: 'publishingUnit',
    allowClear: true
  },
  {
    span: 12,
    label: '发布日期',
    component: 'ADate',
    placeholder: '请选择发布日期',
    prop: 'publishingDate'
  },
  {
    span: 12,
    label: '实施时间',
    component: 'ADate',
    placeholder: '请选择实施日期',
    prop: 'implementationTime'
  },
  {
    span: 24,
    label: '链接/全文',
    component: 'AInput',
    placeholder: '请输入链接/全文',
    prop: 'link',
    allowClear: true
  }
]
const formRules = {
  title: [
    {
      required: true,
      message: '标题不能为空',
      trigger: 'blur'
    },
    {
      min: 1,
      max: 100,
      message: '输入的字数不能超过100个',
      trigger: 'blur'
    }
  ],
  synopsis: [{
    required: true,
    message: '简介不能为空',
    trigger: ['blur']
  }],
  publishingUnit: [{
    required: true,
    message: '发布单位不能为空',
    trigger: ['blur']
  }],
  publishingDate: [{
    required: true,
    message: '发布日期不能为空',
    trigger: ['blur']
  }],
  implementationTime: [{
    required: true,
    message: '实施日期不能为空',
    trigger: ['blur']
  }],
  link: [
    {
      required: true,
      message: '链接不能为空',
      trigger: 'blur'
    },
  ]
}

const formInfo = [{
    label: '标题',
    value: '-',
    key: 'title'
  },
  {
    label: '简介',
    value: '-',
    key: 'synopsis'
  },
  {
    label: '发布单位',
    value: '-',
    key: 'publishingUnit'
  },
  {
    label: '发布日期',
    value: '-',
    key: 'publishingDate'
  },
  {
    label: '实施日期',
    value: '-',
    key: 'implementationTime',
    isVHtml: true
  },
  {
    label: '链接/全文',
    value: '-',
    key: 'link',
    isVHtml: true
  }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}
